<template>
	<div v-if="hasAnyPermission('workflows-diagram-step-and-view-get')">
		<div class="py-4 container-fluid">
			<ToastPrime position="bottom-left" />
			<div class="row">
				<div class="col-12">
					<div class="card" style="height: 655px;">
						<!-- Card header -->
						<div class="pb-0 card-header">
							<div class="d-lg-flex align-items-center row">
								<div class="col-5 d-flex align-items-center">
									<a class="d-flex align-items-center me-3" style="cursor: pointer" @click.prevent="$router.go(-1)">
										<i class="pi pi-chevron-left text-dark mb-0" style="font-size: 1rem"></i>
									</a>
									<div>
										<h5 class="mb-0">Workflow Diagram</h5>
										<span v-if="cardConditionParams.data?.condition" class="fw-bold">{{ cardConditionParams.data.condition }}</span>
									</div>
								</div>
								<div class="col-7 ms-auto">
									<div class="my-auto ms-auto float-end">
										<ButtonPrime v-if="canSaveConditionParams" v-tooltip.top="'Condition Param'" icon="fa fa-cogs" variant="text" rounded severity="primary" size="small" style="margin-left: 5px" @click="conditionParams" />
										<ButtonPrime v-if="hasAnyPermission('workflows-diagram-step-copy')" v-tooltip.top="'Clone Exs Step'" icon="fa fa-clone" variant="text" rounded severity="primary" size="small" style="margin-left: 5px" @click="cloneWorkflowStep" />
										<ButtonPrime v-if="hasAnyPermission('workflows-diagram-step-create')" v-tooltip.top="'Add New Step'" icon="fa fa-plus-square" variant="text" rounded severity="primary" size="small" style="margin-left: 5px" @click="addWorkflowStep" />
										<ButtonPrime v-if="hasAnyPermission('workflows-diagram-step-update')" v-tooltip.top="'Update Exs Step'" icon="fas fa-pencil-alt" variant="text" rounded severity="primary" size="small" style="margin-left: 5px" :disabled="!wfStepNoteForModalAddAndUpdate.certainStepClicked || wfStepNoteForModalAddAndUpdate.certainStepClickedName === '' || ['Start', 'Finish'].includes(wfStepNoteForModalAddAndUpdate.certainStepClickedName)" @click="updateWorkflowStep" />
										<ButtonPrime v-if="hasAnyPermission('workflows-diagram-step-delete')" v-tooltip.top="'Delete Exs Step'" icon="fa fa-trash" variant="text" rounded severity="primary" size="small" style="margin-left: 5px" :disabled="!wfStepNoteForModalAddAndUpdate.certainStepClicked || wfStepNoteForModalAddAndUpdate.certainStepClickedName === '' || ['Start', 'Finish'].includes(wfStepNoteForModalAddAndUpdate.certainStepClickedName)" @click="deleteWorkflowStep" />
										<ButtonPrime v-if="hasAnyPermission('workflows-diagram-save')" v-tooltip.top="'Save diagram'" icon="fas fa-save" variant="text" rounded severity="primary" size="small" style="margin-left: 5px" @click="saveDiagram" />
										<ButtonPrime v-tooltip.top="'Clear diagram'" icon="fa fa-eraser" variant="text" rounded severity="primary" size="small" style="margin-left: 5px" @click="clearDiagram" />
									</div>
								</div>
							</div>
						</div>
						<!-- Card Body -->
						<div class="px-0 pb-0 card-body" style="height: 100px">
							<div v-if="!onLoadDiagram" class="dnd-flow" @drop="onDrop">
								<!-- STEP -->
								<aside style="overflow-y: auto;">
									<div v-for="(row, index) in sortedSteps" :key="index" class="nodes">
										<div class="vue-flow__node-input" :draggable="isDraggable(row.wf_step_code)" :style="{ cursor: isDraggable(row.wf_step_code) ? 'grab' : 'not-allowed', boxShadow: selectedNodeIndex === row.wf_step_code ? '0 0 15px #66ffff' : '' }" @dragstart="onDragStart(row.wf_step_code)" @click="nodesClick(row, row.wf_step_code)">
											{{ row.description }}
										</div>
									</div>
								</aside>

								<MiniMap />
								<!-- DIAGRAM -->
								<VueFlow ref="vueFlow" :nodes="diagram.nodes" :edges="diagram.edges" @dragover="onDragOver" @dragleave="onDragLeave" @connect="addEdge" @nodes-change="handleNodesChange" @edges-change="handleEdgesChange">

									<DropzoneBackground
										:style="{ backgroundColor: isDragOver ? '#e7f3ff' : 'transparent', transition: 'background-color 0.2s ease' }">
										<p v-if="isDragOver">Drop here</p>
									</DropzoneBackground>

									<Controls position="top-right"></Controls>
								</VueFlow>

							</div>
							<div v-else class="row">
								<SkeletonLoading class="col-3 px-4 pt-5" 
								:shapes="[
									{ type: 'line', width: '100%', height: '20px' },
									{ type: 'line', width: '80%', height: '20px' },
									{ type: 'line', width: '60%', height: '20px' }
								]" />
								<SkeletonLoading class="col-8 px-4 pt-5" 
								:shapes="[
									{ type: 'line', width: '100%', height: '20px' },
									{ type: 'line', width: '80%', height: '20px' },
									{ type: 'line', width: '60%', height: '20px' }
								]" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- MODAL ADD AND UPDATE WORKFLOW STEP -->
		<DialogPrime v-model:visible="wfStepNoteForModalAddAndUpdate.visible" :header="wfStepNoteForModalAddAndUpdate.action" :style="{ width: '45rem', margin: '10px' }">
			<div class="mb-2">
				<label for="action_modal_add_or_update">Action <span class="text-danger">*</span></label>
				<SelectPrime id="action_modal_add_or_update" v-model="modalAddAndUpdateWorkflowStep.action" :options="actionOption" option-label="label" option-value="value" size="small" fluid placeholder="Select action" :disabled="wfStepNoteForModalAddAndUpdate.action === 'Update'" :invalid="errorMessage['action'] && modalAddAndUpdateWorkflowStep.action === ''">
				</SelectPrime>
				<small v-if="errorMessage['action'] && modalAddAndUpdateWorkflowStep.action === ''" class="text-danger">{{ errorMessage['action'] }}</small>
			</div>
			<div class="mb-2">
				<label for="description_modal_add_or_update">Description <span class="text-danger">*</span></label>
				<InputText id="description_modal_add_or_update" v-model="modalAddAndUpdateWorkflowStep.description" placeholder="Write Description" fluid :class="errorMessage['description'] && modalAddAndUpdateWorkflowStep.description === '' ? 'border-danger' : ''" size="small" />
				<small v-if="errorMessage['description'] && modalAddAndUpdateWorkflowStep.description === ''" class="text-danger">{{ errorMessage['description'] }}</small>
			</div>
			<div v-if="['approval', 'notification'].includes(modalAddAndUpdateWorkflowStep.action)" class="mb-2">
				<label for="scope_modal_add_or_update">Scope</label>
				<SelectPrime id="scope_modal_add_or_update" v-model="modalAddAndUpdateWorkflowStep.scope" :options="scopeOptions" option-label="label" option-value="value" size="small" fluid show-clear placeholder="Select scope (optional)" />
			</div>
			<div v-if="modalAddAndUpdateWorkflowStep.action === 'notification'" class="mb-2">
				<label for="notification_modal_add_or_update">Notification Template <span class="text-danger">*</span></label>
				<SelectPrime id="notification_modal_add_or_update" v-model="modalAddAndUpdateWorkflowStep.notification_template_code" :options="notificationTemplate" option-label="description" option-value="code" size="small" fluid filter placeholder="Select notification template" :invalid="errorMessage['notification_template_code'] && modalAddAndUpdateWorkflowStep.notification_template_code === ''" />
				<small v-if="errorMessage['notification_template_code'] && modalAddAndUpdateWorkflowStep.notification_template_code === ''" class="text-danger">{{ errorMessage['notification_template_code'] }}</small>
			</div>
			<div v-if="modalAddAndUpdateWorkflowStep.action === 'notification'" class="mb-2">
				<label for="position_modal_add_or_update">Current Step <span class="text-danger">*</span></label>
				<SelectPrime id="position_modal_add_or_update" v-model="modalAddAndUpdateWorkflowStep.position" :options="positionOptions" option-label="role_name" option-value="role_code" size="small" fluid filter placeholder="Select Current Position" :invalid="errorMessage['position'] && modalAddAndUpdateWorkflowStep.position === ''" />
				<small v-if="errorMessage['position'] && modalAddAndUpdateWorkflowStep.position === ''" class="text-danger">{{ errorMessage['position'] }}</small>
			</div>
			<div v-if="modalAddAndUpdateWorkflowStep.action === 'update_value'" class="mb-2">
				<div class="d-flex justify-content-between align-items-center mb-1">
					<label for="action_config_modal_add_or_update" class="mb-0">Action Config <span class="text-danger">*</span></label>
					<ButtonPrime v-if="modalAddAndUpdateWorkflowStep.action_config" type="button" label="Beautify JSON" icon="pi pi-code" size="small" text @click="beautifyActionConfigJson" />
				</div>
				<PrimeTextarea id="action_config_modal_add_or_update" v-model="modalAddAndUpdateWorkflowStep.action_config" placeholder="Enter Action Config (JSON)..." fluid :class="errorMessage['action_config'] ? 'border-danger' : ''" rows="12" style="font-family: monospace; font-size: 12px;" />
				<small v-if="errorMessage['action_config']" class="text-danger">{{ errorMessage['action_config']
				}}</small>
			</div>
			<div v-if="modalAddAndUpdateWorkflowStep.action === 'script'" class="mb-2">
				<label for="script_modal_add_or_update">Script <span class="text-danger">*</span></label>
				<SelectPrime id="script_modal_add_or_update" v-model="modalAddAndUpdateWorkflowStep.script_code" :options="scripts" option-label="description" option-value="code" size="small" fluid filter placeholder="Select Script" :invalid="errorMessage['script'] && modalAddAndUpdateWorkflowStep.script_code === ''"></SelectPrime>
				<small v-if="errorMessage['script'] && modalAddAndUpdateWorkflowStep.script_code === ''" class="text-danger">{{ errorMessage['script'] }}</small>
			</div>
			<div v-if="['approval', 'notification'].includes(modalAddAndUpdateWorkflowStep.action)" class="mb-2">
				<div class="mb-1 d-lg-flex align-items-center row">
					<div class="col-9">
						<label class="form-label">Receiver <span class="text-danger">*</span></label>
					</div>
					<div class="col-3 d-flex justify-content-end">
						<ButtonPrime v-tooltip.top="'Add Operator'" icon="fa fa-plus-square" variant="text" rounded severity="success" size="small" style="margin-left: 5px" @click="addReceiver" />
					</div>
				</div>
				<div>
					<DataTable :value="modalAddAndUpdateWorkflowStep.to" scrollable scroll-height="flex" table-style="min-width: 20rem">
						<Column header-class="bg-light">
							<template #header>
								<b><span style="font-size: 12px">Parameter <span style="font-size: 12px" class="text-danger">*</span></span></b>
							</template>
							<template #body="{ data, index }">
								<Skeleton v-if="modalAddAndUpdateWorkflowStep.onLoad" />
								<SelectPrime v-else v-model="data.to" :options="receiverToOptions" option-label="label" option-value="value" size="small" fluid placeholder="Select Parameter" :invalid="errorMessage.to?.[index]?.to && data.to === ''" @change="data.values = optionalReceiverOptions(data.to) ? [] : ''" />
								<small v-if="errorMessage.to?.[index]?.to && data.to === ''" class="text-danger">{{ errorMessage.to[index].to }}</small>
							</template>
						</Column>
						<Column header-class="bg-light" :style="{ width: '250px', maxWidth: '250px' }" :body-style="{ width: '250px', maxWidth: '250px', padding: '0', whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' }"> <template #header>
								<b><span style="font-size: 12px">Value <span style="font-size: 12px" class="text-danger">*</span></span></b>
							</template>
							<template #body="{ data, index }">
								<Skeleton v-if="modalAddAndUpdateWorkflowStep.onLoad" />
								<template v-else>
									<SelectPrime
										v-if="['departement', 'department'].includes((data.to || '').toLowerCase()) && modalAddAndUpdateWorkflowStep.action === 'notification'"
										v-model="data.values" :options="departmentMaster" option-label="description"
										option-value="code" placeholder="Select option" size="small"
										class="w-full md:w-80"
										:invalid="errorMessage.to?.[index]?.values && !data.values" filter fluid />
									<MultiSelect
										v-else-if="['departement', 'department'].includes((data.to || '').toLowerCase())"
										v-model="data.values" display="chip" :options="departmentMaster"
										option-label="description" option-value="code" placeholder="Select options"
										:max-selected-labels="3" size="small" class="w-full md:w-80"
										:invalid="errorMessage.to?.[index]?.values && !data.values" filter fluid />
									<SelectPrime
										v-else-if="(data.to || '').toLowerCase() === 'section' && modalAddAndUpdateWorkflowStep.action === 'notification'"
										v-model="data.values" :options="sectionMaster" option-label="description"
										option-value="code" placeholder="Select option" size="small"
										class="w-full md:w-80"
										:invalid="errorMessage.to?.[index]?.values && !data.values" filter fluid />
									<MultiSelect v-else-if="['section', 'section_emcr'].includes((data.to || '').toLowerCase())" v-model="data.values" display="chip" :options="sectionMaster" option-label="description" option-value="code" placeholder="Select options" :max-selected-labels="3" size="small" class="w-full md:w-80" :invalid="errorMessage.to?.[index]?.values && !data.values" filter fluid />
									<MultiSelect v-else-if="(data.to || '').toLowerCase() === 'user'" v-model="data.values" display="chip" :options="userMaster" option-label="name" option-value="username" placeholder="Select options" :max-selected-labels="3" size="small" class="w-full md:w-80" :invalid="errorMessage.to?.[index]?.values && !data.values" filter fluid />
									<MultiSelect v-else-if="(data.to || '').toLowerCase() === 'role'" v-model="data.values" display="chip" :options="roleMaster" option-label="role_name" option-value="role_code" placeholder="Select options" :max-selected-labels="3" size="small" class="w-full md:w-80" :invalid="errorMessage.to?.[index]?.values && !data.values" filter fluid />
									<MultiSelect v-else-if="['sub section', 'sub_section', 'sub_section_emcr'].includes((data.to || '').toLowerCase())" v-model="data.values" display="chip" :options="subSection" option-label="description" option-value="code" placeholder="Select options" :max-selected-labels="3" size="small" class="w-full md:w-80" :invalid="errorMessage.to?.[index]?.values && !data.values" filter fluid />
									<SelectPrime v-else-if="(data.to || '').toLowerCase() === 'company' && modalAddAndUpdateWorkflowStep.action === 'notification'" v-model="data.values" :options="companyMaster" option-label="description" option-value="code" placeholder="Select option" size="small" class="w-full md:w-80" :invalid="errorMessage.to?.[index]?.values && !data.values" filter fluid />
									<MultiSelect v-else-if="(data.to || '').toLowerCase() === 'company'" v-model="data.values" display="chip" :options="companyMaster" option-label="description" option-value="code" placeholder="Select options" :max-selected-labels="3" size="small" class="w-full md:w-80" :invalid="errorMessage.to?.[index]?.values && !data.values" filter fluid />
									<!-- plant_emcr / position_id / creator_emcr: selalu multi, tidak wajib (kosong = []) -->
									<MultiSelect v-else-if="optionalReceiverOptions(data.to)" v-model="data.values" display="chip" :options="optionalReceiverOptions(data.to)" option-label="label" option-value="value" placeholder="Select options (optional)" :max-selected-labels="3" size="small" class="w-full md:w-80" filter fluid />
									<InputText v-else v-model="data.values" placeholder="write please" fluid :class="errorMessage.to?.[index]?.values && data.values === '' ? 'border-danger' : ''" size="small" />
								</template>
								<small v-if="errorMessage.to?.[index]?.values && data.values === ''" class="text-danger">{{ errorMessage.to?.[index]?.values }}</small>
							</template>
						</Column>
						<Column header="" header-class="bg-light" :style="{ width: '70px' }" :body-style="{ width: '70px', padding: '0' }">
							<template #body="rowVal">
								<div v-if="(rowVal.index + 1) > 0" class="d-flex justify-content-end me-2">
									<ButtonPrime v-tooltip.bottom="'Delete'" v-tooltip.top="'Delete Result'" icon="pi pi-trash" outlined rounded severity="danger" size="small" style="margin-left: 5px" @click="deleteReceiver(rowVal.index)" />
								</div>
								<div v-else class="m-4"><span /></div>
							</template>
						</Column>
						<template #empty>
							<div class="text-center py-4">
								<img src="/no_data.png" alt="No Data" style="width: 100px; height: 100px; opacity: 0.5;" />
								<p class="text-muted mt-2">No items found</p>
							</div>
						</template>
					</DataTable>
				</div>
			</div>
			<div v-if="['script', 'approval'].includes(modalAddAndUpdateWorkflowStep.action)" class="mb-5">
				<div class="mb-1 d-lg-flex align-items-center row">
					<div class="col-9">
						<label class="form-label">Result <span class="text-danger">*</span></label>
					</div>
					<div class="col-3 d-flex justify-content-end">
						<ButtonPrime v-tooltip.top="'Add Operator'" icon="fa fa-plus-square" variant="text" rounded severity="success" size="small" style="margin-left: 5px" @click="addResult" />
					</div>
				</div>
				<div>
					<DataTable :value="modalAddAndUpdateWorkflowStep.color_set_result" scrollable scroll-height="flex" table-style="min-width: 20rem">
						<Column header-class="bg-light">
							<template #header>
								<b><span style="font-size: 12px">Result <span style="font-size: 12px" class="text-danger">*</span></span></b>
							</template>
							<template #body="{ data, index }">
								<Skeleton v-if="modalAddAndUpdateWorkflowStep.onLoad" />
								<InputText v-else v-model="data.color_set_result" :class="(errorMessage.color_set_result?.[index]?.color_set_result && data.color_set_result === '') ? 'border-danger' : ''" size="small" placeholder="Eg: #eb4034 (HEX)" fluid />
								<small v-if="errorMessage.color_set_result?.[index]?.color_set_result && data.color_set_result === ''" class="text-danger">{{ errorMessage.color_set_result[index].color_set_result }}</small>
							</template>
						</Column>
						<Column header-class="bg-light">
							<template #header>
								<b><span style="font-size: 12px">Color <span style="font-size: 12px" class="text-danger">*</span></span></b>
							</template>
							<template #body="{ data, index }">
								<Skeleton v-if="modalAddAndUpdateWorkflowStep.onLoad" />
								<template v-else>
									<InputGroup>
										<InputGroupAddon style="padding: 2px;">
											<ColorPicker v-model="data.colorRaw" @change="data.color = '#' + (data.colorRaw || '')" />
										</InputGroupAddon>
										<InputText
											v-model="data.color"
											:class="(errorMessage.color_set_result?.[index]?.color && data.color === '') ? 'border-danger' : ''" size="small" placeholder="Eg: #eb4034 (HEX)" fluid
											@input="data.colorRaw = data.color.replace('#', '')" />
									</InputGroup>
								</template>
								<small v-if="errorMessage.color_set_result?.[index]?.color && data.color === ''" class="text-danger">{{ errorMessage.color_set_result?.[index]?.color }}</small>
							</template>
						</Column>
						<Column header="" header-class="bg-light" :style="{ width: '70px' }" :body-style="{ width: '70px', padding: '0' }"> <template #body="rowVal">
								<div v-if="(rowVal.index + 1) > 0" class="d-flex justify-content-end me-2">
									<ButtonPrime v-tooltip.bottom="'Delete'" v-tooltip.top="'Delete Result'" icon="pi pi-trash" outlined rounded severity="danger" size="small" style="margin-left: 5px" @click="deleteResult(rowVal.index)" />
								</div>
								<div v-else class="m-4"><span /></div>
							</template>
						</Column>
						<template #empty>
							<div class="text-center py-4">
								<img src="/no_data.png" alt="No Data" style="width: 100px; height: 100px; opacity: 0.5;" />
								<p class="text-muted mt-2">No items found</p>
							</div>
						</template>
					</DataTable>
				</div>
			</div>

			<div class="col-12 d-flex justify-content-end mt-5 gap-2">
				<ButtonPrime type="button" label="Cancel" severity="secondary" :disabled="modalAddAndUpdateWorkflowStep.onLoad" size="small" @click="wfStepNoteForModalAddAndUpdate.visible = false" />
				<ButtonPrime v-if="canSaveWorkflowStep" type="button" size="small" :disabled="modalAddAndUpdateWorkflowStep.onLoad" @click="addAndUpdateWorkflowStep">
					<span v-if="modalAddAndUpdateWorkflowStep.onLoad"><i class="fas fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;Please wait</span>
					<span v-else>Save</span>
				</ButtonPrime>
			</div>
		</DialogPrime>

		<!-- MODAL CLONE -->
		<DialogPrime v-model:visible="modalCloneWorkflowStep.visible" header="Clone Step" style="width: 30rem; margin: 10px;">
			<div class="mb-2">
				<label for="description_clone_step_modal">Description <span class="text-danger">*</span></label>
				<InputText id="description_clone_step_modal" v-model="modalCloneWorkflowStep.description_clone_step" placeholder="Write Description" fluid />
			</div>
			<div class="mb-5">
				<label for="workflow_step_temp_modal">Workflow Step Template <span class="text-danger">*</span></label>
				<SelectPrime v-model="modalCloneWorkflowStep.workflow_step_template" :options="stepWorkflowOption" option-label="description" option-value="id" size="small" fluid placeholder="Select Workflow Step Templete">
				</SelectPrime>
			</div>
			<div class="col-12 d-flex justify-content-end gap-2">
				<ButtonPrime type="button" label="Cancel" severity="secondary" :disabled="modalCloneWorkflowStep.onLoad" size="small" @click="modalCloneWorkflowStep.visible = false" />
				<ButtonPrime v-if="hasAnyPermission('workflows-diagram-step-copy')" type="button" size="small" :disabled="modalCloneWorkflowStep.onLoad || isDisblBtnClone" @click="toCloneWorkflowStep">
					<span v-if="modalCloneWorkflowStep.onLoad"><i class="fas fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;Please wait</span>
					<span v-else>Save</span>
				</ButtonPrime>
			</div>
		</DialogPrime>

		<!-- MODAL PARAMS -->
		<DialogPrime v-model:visible="cardConditionParams.visible" header="Condition Params" style="width: 70rem; max-width: 95vw; margin: 10px;">
			<div class="col-12 mt-1 text-end pe-3">
				<ButtonPrime type="button" label="Add Params" severity="primary" size="small" @click="addParamsOrValuesArr('params')" />
			</div>
			<div v-if="cardConditionParams.data?.condition_params?.length > 0">
				<div v-for="(row, k) in cardConditionParams.data.condition_params" :key="k">
					<div class="col-12 mx-3 my-4 card shadow-lg" style="max-width: 95%;">
						<div class="px-0 pt-3 pb-0 card-body position-relative">
							<div class="row">
								<div class="col-12 mx-2 my-2 text-start row">
									<div class="col-4">
										<div class="my-auto">
											<Skeleton v-if="cardConditionParams.onLoad" />
											<SelectPrime v-else v-model="row.column" :options="columnOptions" option-label="label" option-value="value" placeholder="Select column" filter fluid :invalid="errorMessageParam[k]?.column && !row.column" @change="row.values.forEach(v => v.from = '')" />
										</div>
									</div>
									<div class="col-3">
										<div class="my-auto">
											<Skeleton v-if="cardConditionParams.onLoad" />
											<SelectPrime v-else v-model="row.operator" :options="cardOperatorOptions" option-label="label" option-value="value" fluid placeholder="Select operator" :disabled="k === 0" :invalid="errorMessageParam[k]?.operator && !row.operator">
											</SelectPrime>
										</div>
									</div>
									<div class="col-5 ms-auto d-flex justify-content-end align-items-center">
										<div class="my-auto ms-auto float-end">
											<ButtonPrime v-tooltip.top="'Delete Operation'" icon="fa fa-minus-circle" variant="text" rounded severity="danger" size="small" @click="deleteParamsOrValuesArr('params', k)" />
											<ButtonPrime v-tooltip.top="'Add Operation'" icon="fa fa-plus-square" variant="text" style="margin-right: 5px;" rounded severity="success" size="small" @click="addParamsOrValuesArr('valuesArr', k)" />
										</div>
									</div>
								</div>
								<div class="col-12" style="max-height: 350px; overflow: auto">
									<DataTable :value="row.values" scrollable scroll-direction="both" scroll-height="flex" table-style="min-width: 70rem">
										<Column header-class="bg-light" :style="{ minWidth: '110px' }">
											<template #header>
												<b><small>Operation <small class="text-danger">*</small></small></b>
											</template>
											<template #body="rowVal">
												<Skeleton v-if="cardConditionParams.onLoad" />
												<SelectPrime v-else v-model="rowVal.data.operation" :options="operatorOptions" option-label="label" option-value="value" fluid placeholder="Select operation" :invalid="errorMessageParam[k]?.operation && !rowVal.data.operation">
												</SelectPrime>
												<small v-if="errorMessageParam[k]?.operation && !rowVal.data.operation" class="text-danger">{{ errorMessageParam[k]?.operation }}</small>
											</template>
										</Column>
										<Column header-class="bg-light" :style="{ minWidth: '170px' }">
											<template #header>
												<b><small>Condition <small class="text-danger">*</small></small></b>
											</template>
											<template #body="rowVal">
												<Skeleton v-if="cardConditionParams.onLoad" />
												<SelectPrime v-else v-model="rowVal.data.condition" :options="conditionOptions" option-label="label" option-value="value" fluid placeholder="Select condition" :invalid="errorMessageParam[k]?.condition && !rowVal.data.condition">
												</SelectPrime>
												<small v-if="errorMessageParam[k]?.condition && !rowVal.data.condition" class="text-danger">{{ errorMessageParam[k]?.condition }}</small>
											</template>
										</Column>
										<Column header-class="bg-light" :style="{ minWidth: '260px' }">
											<template #header>
												<b><small>From <small class="text-danger">*</small></small></b>
											</template>
											<template #body="rowVal">
												<Skeleton v-if="cardConditionParams.onLoad" />
												<MultiSelect v-else :model-value="rowVal.data.from ? [rowVal.data.from] : []" @update:model-value="(val) => rowVal.data.from = val.length ? val[val.length - 1] : ''" v-bind="fromFieldConfig(row.column)" display="chip" placeholder="Select option" filter fluid :invalid="errorMessageParam[k]?.from && !rowVal.data.from" />
												<small v-if="errorMessageParam[k]?.from && !rowVal.data.from" class="text-danger">{{ errorMessageParam[k]?.from }}</small>
											</template>
										</Column>
										<Column header-class="bg-light" :style="{ minWidth: '100px' }">
											<template #header>
												<b><small>To</small></b>
											</template>
											<template #body="rowVal">
												<Skeleton v-if="cardConditionParams.onLoad" />
												<InputText v-else v-model="rowVal.data.to" placeholder="Fill the field" fluid />
											</template>
										</Column>
										<Column header="" header-class="bg-light" :style="{ width: '70px' }" :body-style="{ width: '70px', padding: '0' }">
											<template #body="rowVal">
												<div v-if="!cardConditionParams.onLoad">
													<ButtonPrime v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger" size="small" style="margin-left: 5px" @click="deleteParamsOrValuesArr('valuesArr', k, rowVal.index)" />
												</div>
												<div v-else class="m-4"><span /></div>
											</template>
										</Column>
										<template #empty>
											<div class="text-center py-4">
												<img src="/no_data.png" alt="No Data" style="width: 100px; height: 100px; opacity: 0.5;" />
												<p class="text-muted mt-2">No items found</p>
											</div>
										</template>
									</DataTable>
								</div>
								<div class="col-12 mt-5"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<template #footer>
				<div class="col-12 d-flex justify-content-end mt-4 mb-3 gap-2">
					<ButtonPrime type="button" label="Cancel" severity="secondary" :disabled="cardConditionParams.onLoad" size="small" @click="cardConditionParams.visible = false" />
					<ButtonPrime v-if="canSaveConditionParams" type="button" size="small" :disabled="cardConditionParams.onLoad" @click="saveParams">
						<span v-if="cardConditionParams.onLoad"><i
								class="fas fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;Please wait</span>
						<span v-else>Save</span>
					</ButtonPrime>
				</div>
			</template>
		</DialogPrime>
	</div>
	<NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import NoAccess from "@/components/NoAccess.vue";
import { VueFlow, useVueFlow } from '@vue-flow/core'
import { MiniMap } from '@vue-flow/minimap'
import { Controls } from '@vue-flow/controls'
import DropzoneBackground from './DropzoneBackground.vue'
import SkeletonLoading from "@/components/SkeletonLoading.vue";
// import { getTask } from './dummyWorkflowDiagram.js';
// getStepWorkflow, getNodeWorkflow, getEdgeWorkflow, usedNodes, getConditionParams,
import api from '@/helpers/api';
import workflowService from '@/services/generalSettings/workflowService'
import notificationTemplateService from '@/services/generalSettings/notificationTemplateService'
import generalMasterDataService from '@/services/generalMasterData/generalMasterDataService'
import manageAccountService from '@/services/manageAccount/manageAccountService'
import manageRoleService from '@/services/manageAccount/manageRoleService'
import formConfigService from '@/services/materialCatalogingRequest/formConfigService'
// import mailTemplateService from '@/services/generalSettings/mailTemplateService'
// import taskService from '@/services/generalSettings/taskService'
// import tableObjectService from '@/services/generalSettings/tableObjectService'
// import scriptService from '@/services/generalSettings/scriptService'

export default {
	components: {
		VueFlow,
		MiniMap,
		Controls,
		DropzoneBackground,
		SkeletonLoading,
		NoAccess,
	},
	data() {
		const { toObject, addNodes, updateNode, screenToFlowCoordinate, onNodesInitialized } = useVueFlow();

		return {
			wfcCode: this.$route.params.wfcCode || "",
			onLoadDiagram: false,
			isDragging: false,
			isDragOver: false,
			draggedNode: null,
			// usedNodes: usedNodes,
			usedNodes: [],
			toObject,
			addNodes,
			updateNode,
			screenToFlowCoordinate,
			onNodesInitialized,
			errorMessage: [],
			errorMessageParam: [],
			selectedNodeIndex: null,
			diagram: {
				steps: [],
				nodes: [],
				edges: [],
				// steps: getStepWorkflow,
				// nodes: getNodeWorkflow,
				// edges: getEdgeWorkflow
			},
			wfStepNoteForModalAddAndUpdate: {
				visible: false,
				action: 'Create',
				certainStepClicked: false,
				certainStepClickedKey: '',
				certainStepClickedName: '',
				certainStepClickedId: null
			},
			modalAddAndUpdateWorkflowStep: {
				action: '',
				description: '',
				scope: '',
				action_config: '',
				to: '',
				script_code: '',
				task_code: '',
				view_type: '',
				notification_template_code: '',
				position: '',
				department: '',
				section: '',
				sub_section: '',
				color_set_result: [
					{ color_set_result: "", color: "" }
				],
				result: {},
				send_wa: null,
				onLoad: false
			},
			modalCloneWorkflowStep: {
				visible: false,
				description_clone_step: '',
				workflow_step_template: '',
				onLoad: false
			},
			cardConditionParams: {
				visible: false,
				// data: getConditionParams,
				data: {},
				onLoad: false,
				loadTimeout: null
			},
			notificationTemplate: [],
			departmentMaster: [],
			sectionMaster: [],
			companyMaster: [],
			userMaster: [],
			plantMaster: [],
			positionMaster: [],
			scripts: [],
			roleMaster: [],
			subSection: [],
			mrpTypeOptions: [],
			receiverToOptions: [
				{ label: "User", value: "user" },
				{ label: "Role", value: "role" },
				{ label: "Department", value: "department" },
				{ label: "Section", value: "section" },
				{ label: "Sub Section", value: "sub_section" },
				{ label: "Section MCR", value: "section_emcr" },
				{ label: "Sub Section MCR", value: "sub_section_emcr" },
				{ label: "Company", value: "company" },
				{ label: "Plant Emcr", value: "plant_emcr" },
				{ label: "Position ID", value: "position_id" },
				{ label: "Creator Emcr", value: "creator_emcr" }
			],
			columnOptions: [
				{ label: "Type", value: "type" },
				{ label: "Role", value: "role" },
				{ label: "Department", value: "department" },
				{ label: "Section", value: "section" },
				{ label: "Sub Section", value: "sub_section" },
				{ label: "Company", value: "company" }
			],
			cardOperatorOptions: [
				{ label: "AND", value: "AND" },
				{ label: "OR", value: "OR" }
			],
			conditionOptions: [
				{ label: "Equals (=)", value: "equals" },
				{ label: "Not Equal (!=)", value: "not_equal" },
				{ label: "Contains", value: "contains" },
				{ label: "Not Contains", value: "not_contains" },
				{ label: "Between", value: "between" },
				{ label: "Start With", value: "start_with" },
				{ label: "End With", value: "end_with" }
			],
			operatorOptions: [
				{ label: "AND", value: "AND" },
				{ label: "AND ILIKE", value: "AND ILIKE" },
				{ label: "AND IN", value: "AND IN" },
				{ label: "OR", value: "OR" },
				{ label: "OR ILIKE", value: "OR ILIKE" },
				{ label: "OR IN", value: "OR IN" }
			],
			scopeOptions: [
				{ label: "Plant", value: "plant" },
			],
			actionOption: [
				{ label: "Notification", value: "notification" },
				{ label: "Update Value", value: "update_value" },
				{ label: "Execute Script", value: "script" },
				{ label: "Approval", value: "approval" },
			],
			resultOption: [
				{ label: "Approve", value: "approve" },
				{ label: "Send Back", value: "send_back" },
				{ label: "Reject", value: "reject" },
				{ label: "Success", value: "success" },
				{ label: "Failed", value: "failed" },
			],
		}
	},
	computed: {
		...mapState({
			authUserPermissions: (state) => state.auth.userHasPermissions || [],
			authUser: (state) => state.auth.user || {},
		}),
		// Opsi receiver creator_emcr dari daftar akun yang sama dengan receiver `user` (getUser).
		creatorOptions() {
			return (this.userMaster || []).filter(item => item.namecode)
				.map(item => ({ value: item.namecode, label: `${item.namecode} - ${item.name || ''}` }))
		},
		sortedSteps() {
			if (!Array.isArray(this.diagram.steps)) return [];
			return [...this.diagram.steps].sort((a, b) =>
				(a.description || '').localeCompare(b.description || '')
			);
		},
		stepWorkflowOption() {
			if (!Array.isArray(this.diagram.steps)) return [];
			const opt = this.diagram.steps.filter(item => item.action !== 'start' && item.action !== 'finish')
			return opt;
		},
		isDisblBtnClone() {
			return (!this.modalCloneWorkflowStep.description_clone_step || !this.modalCloneWorkflowStep.workflow_step_template)
		},
		positionOptions() {
			return [...this.roleMaster, { role_code: "SAP", role_name: "SAP" }];
		},
		// wfStepNoteForModalAddAndUpdate.action 'Create' -> diagram-step-create, selain itu -> diagram-step-update
		canSaveWorkflowStep() {
			if (this.wfStepNoteForModalAddAndUpdate.action === 'Create') return this.hasAnyPermission('workflows-diagram-step-create');
			return this.hasAnyPermission('workflows-diagram-step-update');
		},
		// cardConditionParams.data.id ada -> edit-condition, kalau belum ada -> add-condition
		canSaveConditionParams() {
			if (this.cardConditionParams.data?.id) return this.hasAnyPermission('workflows-edit-condition');
			return this.hasAnyPermission('workflows-add-condition');
		},
	},
	watch: {
		"modalAddAndUpdateWorkflowStep.action": {
			handler() {
				this.errorMessage = []
				if (this.wfStepNoteForModalAddAndUpdate.action === 'Create') {
					if (this.modalAddAndUpdateWorkflowStep.action === 'approval') {
						this.modalAddAndUpdateWorkflowStep.to = [{ to: "role", values: '' }]
						this.modalAddAndUpdateWorkflowStep.color_set_result = [{ color_set_result: "approve", color: "" }, { color_set_result: "send_back", color: "" }, { color_set_result: "reject", color: "" }]
					} else if (this.modalAddAndUpdateWorkflowStep.action === 'notification') {
						this.modalAddAndUpdateWorkflowStep.to = [{ to: "role", values: '' }]
						this.modalAddAndUpdateWorkflowStep.color_set_result = [{ color_set_result: "", color: "" }]
					} else if (this.modalAddAndUpdateWorkflowStep.action === 'update_value') {
						const defaultJson = {
							"action_config": {
								"relations": [],
								"target_model": "",
								"update_fields": [
									{
										"value": "",
										"column": "",
										"value_type": ""
									}
								]
							}
						};
						this.modalAddAndUpdateWorkflowStep.action_config = JSON.stringify(defaultJson, null, 2);
						this.modalAddAndUpdateWorkflowStep.to = ""
						this.modalAddAndUpdateWorkflowStep.color_set_result = [{ color_set_result: "", color: "" }]
					} else {
						this.modalAddAndUpdateWorkflowStep.to = ""
						this.modalAddAndUpdateWorkflowStep.color_set_result = [{ color_set_result: "", color: "" }]

					}
				}
			}
		},
	},
	mounted() {
		if (this.hasAnyPermission('workflows-diagram-step-and-view-get')) {
			this.getStepWorkflow();
			this.getNotificationTemplate();
			this.getDepartment();
			this.getSection();
			this.getSubSection();
			this.getCompany();
			this.getUser();
			this.getPlant();
			this.getPosition();
			this.getScripts();
			this.getRoles();
			this.getMrpType();
		}
		// this.getDiagram();
	},
	methods: {
		hasAnyPermission(...perms) {
			return perms.some((p) => this.authUserPermissions.includes(p));
		},
		beautifyActionConfigJson() {
			try {
				const obj = JSON.parse(this.modalAddAndUpdateWorkflowStep.action_config);
				this.modalAddAndUpdateWorkflowStep.action_config = JSON.stringify(obj, null, 2);
				delete this.errorMessage['action_config'];
			} catch (e) {
				this.$toastNotifPrime('error', "Invalid JSON", "Could not format the config because it's not a valid JSON string");
			}
		},
		async getNotificationTemplate() {
			try {
				const response = await api(this, notificationTemplateService.list({ limit: 100, page: 1 }), false)
				this.notificationTemplate = response.data.data
			} catch (error) {
				this.notificationTemplate = []
			}
		},
		async getDepartment() {
			try {
				const response = await api(this, generalMasterDataService.list('department', { limit: 0 }), false)
				this.departmentMaster = (response.data || []).map(item => ({
					...item,
					description: `${item.code} - ${item.description}`
				}))
			} catch (error) {
				this.departmentMaster = []
			}
		},
		async getSection() {
			try {
				const response = await api(this, generalMasterDataService.list('section', { limit: 0 }), false)
				this.sectionMaster = (response.data || []).map(item => ({
					...item,
					description: `${item.code} - ${item.description}`
				}))
			} catch (error) {
				this.sectionMaster = []
			}
		},
		async getSubSection() {
			try {
				const response = await api(this, generalMasterDataService.list('sub-section', { limit: 0 }), false)
				this.subSection = (response.data || []).map(item => ({
					...item,
					description: `${item.code} - ${item.description}`
				}))
			} catch (error) {
				this.subSection = []
			}
		},
		async getCompany() {
			try {
				const response = await api(this, generalMasterDataService.list('company', { limit: 0 }), false)
				this.companyMaster = (response.data || []).map(item => ({
					...item,
					description: `${item.code} - ${item.description}`
				}))
			} catch (error) {
				this.companyMaster = []
			}
		},
		// Satu request akun (company user login, tanpa limit) untuk receiver `user` (value username) & `creator_emcr`
		// (value namecode = isi emcrs.created_by, lihat computed creatorOptions).
		async getUser() {
			try {
				const response = await api(this, manageAccountService.list({ company_code: this.authUser.company_code, limit: 0 }), false)
				this.userMaster = response.data.data || response.data || []
			} catch (error) {
				this.userMaster = []
			}
		},
		// Opsi receiver plant_emcr (plant) & position_id (posisi), difilter client user login.
		async getPlant() {
			try {
				const response = await api(this, generalMasterDataService.list('plant', { client: this.authUser.client_code, limit: 0 }), false)
				const rows = Array.isArray(response?.data) ? response.data : (response?.data?.data || [])
				this.plantMaster = rows.map(item => ({ value: item.code, label: `${item.code} - ${item.description || ''}` }))
			} catch (error) {
				this.plantMaster = []
			}
		},
		async getPosition() {
			try {
				const response = await api(this, generalMasterDataService.list('position', { company: this.authUser.company_code, limit: 0 }), false)
				const rows = Array.isArray(response?.data) ? response.data : (response?.data?.data || [])
				this.positionMaster = rows.map(item => ({ value: item.code, label: item.label || `${item.code} - ${item.name || ''}` }))
			} catch (error) {
				this.positionMaster = []
			}
		},
		// Receiver yang selalu multi & tidak wajib -> daftar opsinya; receiver lain -> null.
		optionalReceiverOptions(to) {
			return {
				plant_emcr: this.plantMaster,
				position_id: this.positionMaster,
				creator_emcr: this.creatorOptions,
			}[(to || '').toLowerCase()] || null
		},
		async getRoles() {
			try {
				const response = await api(this, manageRoleService.list({ limit: 0 }), false)
				const roles = response.data.data || response.data || []
				this.roleMaster = roles.map(role => ({
					role_code: role.name,
					role_name: role.name
				}))
			} catch (error) {
				this.roleMaster = []
			}
		},
		async getMrpType() {
			try {
				const response = await api(this, formConfigService.get('mcr_type'), false)
				let types = response?.data?.data || []
				this.mrpTypeOptions = types.map(t => ({
					label: `${t.code} - ${t.description}`,
					value: t.code
				}))
			} catch (error) {
				this.mrpTypeOptions = []
			}
		},
		fromFieldConfig(column) {
			const configs = {
				type: { options: this.mrpTypeOptions, optionLabel: 'label', optionValue: 'value' },
				role: { options: this.roleMaster, optionLabel: 'role_name', optionValue: 'role_code' },
				department: { options: this.departmentMaster, optionLabel: 'description', optionValue: 'code' },
				departement: { options: this.departmentMaster, optionLabel: 'description', optionValue: 'code' },
				section: { options: this.sectionMaster, optionLabel: 'description', optionValue: 'code' },
				sub_section: { options: this.subSection, optionLabel: 'description', optionValue: 'code' },
				'sub section': { options: this.subSection, optionLabel: 'description', optionValue: 'code' },
				company: { options: this.companyMaster, optionLabel: 'description', optionValue: 'code' },
			}
			return configs[(column || '').toLowerCase()] || { options: [], optionLabel: 'label', optionValue: 'value' }
		},
		async getScripts() {
			try {
				const response = await api(this, workflowService.getScriptTemplates({ limit: 0 }), false)
				this.scripts = response.data || []
			} catch (error) {
				this.scripts = []
			}
		},
		async getStepWorkflow() {
			this.onLoadDiagram = true
			try {
				const response = await api(this, workflowService.diagramStepGet({ wfc_code: this.wfcCode }), false)
				this.diagram.steps = response.data
				this.cardConditionParams.data = response.data[0]?.workflow || {}

				await this.getDiagram()

			} catch (error) {
				this.handleErrorObjectNested(error)
				this.diagram.steps = []
				this.diagram.nodes = []
				this.diagram.edges = []
			} finally {
				this.onLoadDiagram = false
			}
		},
		async getDiagram() {
			try {
				let response = await api(this, workflowService.diagramView(this.wfcCode), false)

				if (response.data.nodes && response.data.edges) {
					this.diagram.nodes = response.data.nodes
					this.diagram.edges = response.data.edges.map(edge => {
						edge.id = `${edge.source} - ${edge.target}`;
						return edge;
					})
					this.usedNodes = (response.data.nodes?.length ? response.data.nodes.map(item => item.id) : [])
				}
			} catch (error) {
				this.handleErrorObjectNested(error)
				this.diagram.nodes = []
				this.diagram.egdes = []
			}
		},
		isDraggable(index) {
			return !Object.values(this.usedNodes).includes(index)
		},
		nodesClick(row, index) {
			this.selectedNodeIndex = index
			this.wfStepNoteForModalAddAndUpdate.certainStepClicked = true
			this.wfStepNoteForModalAddAndUpdate.certainStepClickedKey = row.wf_step_code
			this.wfStepNoteForModalAddAndUpdate.certainStepClickedName = row.description
			this.wfStepNoteForModalAddAndUpdate.certainStepClickedId = row.id
		},
		onDragStart(index) {
			this.draggedNode = index
			this.isDragging = true
			document.addEventListener('drop', this.onDragEnd)
		},
		onDragOver(event) {
			event.preventDefault()

			this.isDragOver = true

			if (event.dataTransfer) {
				event.dataTransfer.dropEffect = 'move'
			}
		},
		onDragLeave() {
			this.isDragOver = false
		},
		onDragEnd() {
			this.isDragging = false
			this.isDragOver = false
			document.removeEventListener('drop', this.onDragEnd)
		},
		onDrop(event) {
			const position = this.screenToFlowCoordinate({
				x: event.clientX,
				y: event.clientY,
			})

			const draggedNode = this.diagram.steps.find(item => item.wf_step_code === this.draggedNode);
			const nodeType = (draggedNode.description == 'Start') ? 'input' : (draggedNode.description == 'Finish') ? 'output' : 'default';
			const nodeStyle = (draggedNode.description == 'Finish') ? { border: '1px solid blue' } : {};
			const nodeFor = (draggedNode.action == 'approval') ? 'approval' : (draggedNode.action == 'query') ? 'query' : (draggedNode.action == 'script') ? 'script' : null;

			const newNode = {
				id: draggedNode.wf_step_code,
				type: nodeType,
				data: { label: draggedNode.description },
				position,
				style: nodeStyle,
				nodeFor: nodeFor,
				actionStep: draggedNode.action,
				result: (draggedNode.data.result && Object.keys(draggedNode.data.result).length) ? draggedNode.data.result : {},
				color_set_result: (draggedNode.data.color_set_result && Object.keys(draggedNode.data.color_set_result).length) ? draggedNode.data.color_set_result : {},
				next_step: draggedNode.data.next_step || null
			}

			const { off } = this.onNodesInitialized(() => {
				this.updateNode(draggedNode.id, (node) => ({
					position: { x: node.position.x - node.dimensions.width / 2, y: node.position.y - node.dimensions.height / 2 },
				}))

				off()
			})

			this.addNodes(newNode); // Menambahkan nodes pada diagram
			const newKey = Object.keys(this.usedNodes).length
			this.usedNodes[newKey] = this.draggedNode // Menambahkan step code yang didrag pada object semua node yang sudah dipakai
		},
		addEdge(params) {
			const vueFlow = this.$refs.vueFlow;
			const diagramData = vueFlow.toObject()
			const sourceNode = diagramData.nodes.find(node => node.id === params.source);

			if (['approval', 'query', 'script'].includes(sourceNode.actionStep)) {
				// dinamic button menyesuaikan result dalam object step
				const resultKeys = Object.keys(sourceNode.color_set_result || {});
				const buttonsHtml = resultKeys.map(key => {
					const color = sourceNode.color_set_result[key];
					return `<button class="btn btn-sm" id="${key}" style="background-color: ${color}; color: white; margin: 5px;">${this.toTitleCase(key)}</button>`;
				}).join('');

				this.$swal({
					title: 'Choose an action',
					html: `<div>${buttonsHtml}</div>`,
					showCancelButton: false,
					showConfirmButton: false,
					didRender: () => {
						const handleEdgeAction = (event) => {
							const action = event.target.id;
							if (!action) return;

							const color = sourceNode.color_set_result[action];
							const newEdge = {
								id: `${params.source}-${params.target}`,
								source: params.source,
								target: params.target,
								style: { stroke: color },
								label: this.toTitleCase(action),
								labelKey: action
							};

							this.diagram.edges.push(newEdge);
							this.$swal.close();
							// update value setiap property result
							this.updateNode(newEdge.source, (node) => {
								const updatedResult = { ...node.result, [newEdge.labelKey]: newEdge.target };
								return { ...node, result: updatedResult, next_step: null };
							});
						};

						resultKeys.forEach(key => {
							const btn = document.getElementById(key);
							if (btn) {
								btn.addEventListener('click', handleEdgeAction);
							}
						});
					}
				});
			} else {
				const newEdge = {
					id: `${params.source}-${params.target}`,
					source: params.source,
					target: params.target,
				};

				this.diagram.edges.push(newEdge);
				// step linear (bukan approval/query/script) -> next_step-nya langsung target edge ini
				this.updateNode(newEdge.source, (node) => ({ ...node, next_step: newEdge.target }));
			}

		},
		toTitleCase(action) {
			const spaced = action
				.replace(/([a-z])([A-Z])/g, '$1 $2') // camelCase -> camel Case
				.replace(/_/g, ' ')                 // snake_case -> snake case

			return spaced.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
		},
		handleNodesChange(changes) {
			changes.forEach((change) => {
				if (change.type === 'remove') {
					// this.usedNodes.splice(change.id - 1, 1);
					this.usedNodes = this.$refs.vueFlow.toObject().nodes.reduce((allVal, item, index) => {
						allVal[index] = item.id;
						return allVal;
					}, {})

					this.diagram.edges = this.$refs.vueFlow.toObject().edges.map(item => item)
				}
			});
		},
		handleEdgesChange(changes) {
			// Snapshot edges lama SEBELUM di-reassign, biar tiap edge yang dihapus di batch ini
			// tetap bisa dicari sumber/labelKey-nya (dipakai buat bersihin result/next_step basi).
			const previousEdges = this.diagram.edges;
			changes.forEach((change) => {
				if (change.type === 'remove') {
					const removedEdge = previousEdges.find((edge) => edge.id === change.id);
					if (removedEdge) {
						this.updateNode(removedEdge.source, (node) => {
							if (['approval', 'query', 'script'].includes(node.actionStep)) {
								if (removedEdge.labelKey && node.result && Object.prototype.hasOwnProperty.call(node.result, removedEdge.labelKey)) {
									const updatedResult = { ...node.result };
									delete updatedResult[removedEdge.labelKey];
									return { ...node, result: updatedResult };
								}
								return node;
							}

							if (node.next_step === removedEdge.target) {
								return { ...node, next_step: null };
							}
							return node;
						});
					}

					this.diagram.edges = this.$refs.vueFlow.toObject().edges.map(item => item)
				}
			});
		},
		saveDiagram() {
			const vueFlow = this.$refs.vueFlow;
			const diagramSnapshot = vueFlow.toObject();
			const edges = diagramSnapshot.edges;
			const setFormPositionNodes = diagramSnapshot.nodes.map(node => {
				// biar jadi integer bukan float
				node.position.x = Math.round(node.position.x);
				node.position.y = Math.round(node.position.y);

				// Jaga-jaga buat node lama yang belum punya key next_step sama sekali (mis. dibuat sebelum logic ini ada, jadi tidak sempat kena onDrop()/addEdge() terbaru) -> derive dari edges. Kalau key-nya udah ada (termasuk null hasil addEdge()/handleEdgesChange()), jangan disentuh.
				if (!('next_step' in node)) {
					if (['approval', 'query', 'script'].includes(node.actionStep)) {
						node.next_step = null;
					} else {
						const nextEdge = edges.find((edge) => edge.source === node.id);
						node.next_step = nextEdge ? nextEdge.target : null;
					}
				}

				return node;
			}).sort((a, b) => {
				// Prioritasin `input` ke posisi pertama
				if (a.type === 'input') return -1;
				if (b.type === 'input') return 1;
				// Prioritasin `output` ke posisi terakhir
				if (a.type === 'output') return 1;
				if (b.type === 'output') return -1;
				// Pertahankan urutan untuk `default`
				return 0;
			})

			let diagramData = diagramSnapshot
			diagramData.nodes = setFormPositionNodes
			const result = JSON.stringify(diagramData);

			this.onLoadDiagram = true
			setTimeout(async () => {
				try {
					await api(this, workflowService.diagramSave(this.wfcCode, result))
					this.getStepWorkflow()
					// this.getDiagram()
				} catch (error) {
					this.handleErrorObjectNested(error)
				}
				// finally {
				// 	this.onLoadDiagram = false
				// }
			}, 500)
		},
		clearDiagram() {
			this.confirmDialog("You won't be able to revert the steps!", "clear it").then((result) => {
				if (result.isConfirmed) {
					// kosongin position
					this.diagram.nodes = this.diagram.nodes.filter(i => ["start", "finish"].includes(i.actionStep))
					this.diagram.edges = []
					this.usedNodes = []

					this.$swal({
						icon: "success",
						title: "Success",
						text: "Clear diagram run successfully, then please click Save Diagram button",
					});
				}
			})
		},
		addWorkflowStep() {
			this.wfStepNoteForModalAddAndUpdate.action = 'Create'
			this.wfStepNoteForModalAddAndUpdate.visible = true

			// menghapus modal values untuk create
			for (const field of Object.keys(this.modalAddAndUpdateWorkflowStep)) {
				if (field === 'send_wa') {
					this.modalAddAndUpdateWorkflowStep[field] = null
				} else if (field === 'onLoad') {
					this.modalAddAndUpdateWorkflowStep[field] = false
				} else if (field === 'color_set_result') {
					this.modalAddAndUpdateWorkflowStep[field] = [{ color_set_result: "approve", color: "" }, { color_set_result: "send_back", color: "" }, { color_set_result: "reject", color: "" }]
				} else if (field === 'result') {
					this.modalAddAndUpdateWorkflowStep[field] = {}
				} else { this.modalAddAndUpdateWorkflowStep[field] = '' }
			}
		},
		addReceiver() {
			this.modalAddAndUpdateWorkflowStep.to.push({ to: "role", values: "" })
		},
		deleteReceiver(idx) {
			this.modalAddAndUpdateWorkflowStep.to.splice(idx, 1)
		},
		addResult() {
			this.modalAddAndUpdateWorkflowStep.color_set_result.push({ color_set_result: "", color: "", colorRaw: "" })
		},
		deleteResult(idx) {
			this.modalAddAndUpdateWorkflowStep.color_set_result.splice(idx, 1)
		},
		updateWorkflowStep() {
			this.wfStepNoteForModalAddAndUpdate.action = 'Update'
			this.wfStepNoteForModalAddAndUpdate.visible = true
			let formatedResult = []
			let formatedReceiver = []
			
			// mengload existing modal values untuk update
			let getWorkflowSelected = this.diagram.steps.find(nd => nd.wf_step_code === this.wfStepNoteForModalAddAndUpdate.certainStepClickedKey)

			if (getWorkflowSelected.data?.color_set_result) {
				formatedResult = Object.entries(getWorkflowSelected.data.color_set_result).map(([color_set_result, color]) => ({ 
					color_set_result, 
					color,
					colorRaw: color ? color.replace('#', '') : ''
				}))
			}

			// Standardize receiver loading for both formats (receivers array or to object)
			const rawReceivers = getWorkflowSelected.data?.receivers || 
								 (getWorkflowSelected.data?.to ? Object.entries(getWorkflowSelected.data.to).map(([to, values]) => ({ to, values })) : null);

			if (Array.isArray(rawReceivers)) {
				formatedReceiver = rawReceivers.map(r => {
					let finalValues = r.values;
					// Pick first element if UI expects single select (only for notification action)
					if (getWorkflowSelected.action === 'notification' && ['departement', 'department', 'section', 'company'].includes((r.to || '').toLowerCase())) {
						finalValues = Array.isArray(r.values) ? (r.values[0] ?? '') : r.values;
					}
					// plant_emcr / position_id / creator_emcr selalu MultiSelect -> nilainya harus array.
					if (['plant_emcr', 'position_id', 'creator_emcr'].includes((r.to || '').toLowerCase()) && !Array.isArray(finalValues)) {
						finalValues = finalValues ? [finalValues] : [];
					}
					return {
						to: r.to,
						values: finalValues
					};
				});
			} else {
				formatedReceiver = [{ to: "role", values: '' }];
			}

			const fieldMappings = {
				notification: {
					result: getWorkflowSelected.data?.result || {},
					scope: getWorkflowSelected.data?.scope || '',
					notification_template_code: getWorkflowSelected.data?.notification_template_code || '',
					position: getWorkflowSelected.data?.position || '',
					send_wa: getWorkflowSelected.data?.send_wa || '',
					to: formatedReceiver,
				},
				update_value: {
					action_config: getWorkflowSelected.data?.action_config
						? (typeof getWorkflowSelected.data.action_config === 'string'
							? getWorkflowSelected.data.action_config
							: JSON.stringify(getWorkflowSelected.data.action_config, null, 4))
						: '',
				},
				script: {
					script_code: getWorkflowSelected.data?.script_code || '',
					color_set_result: formatedResult,
					result: getWorkflowSelected.data?.result || {}
				},
				approval: {
					scope: getWorkflowSelected.data?.scope || '',
					to: formatedReceiver,
					color_set_result: formatedResult,
					result: getWorkflowSelected.data?.result || {}
				}
			};

			this.modalAddAndUpdateWorkflowStep = {
				onLoad: false,
				scope: '',
				action: getWorkflowSelected?.action,
				description: getWorkflowSelected?.description,
				...(fieldMappings[getWorkflowSelected?.action] || {})
			};
		},
		addAndUpdateWorkflowStep() {
			this.errorMessage = []
			this.modalAddAndUpdateWorkflowStep.wfcCode = this.wfcCode

			let returnPayloadAndValidate = this.validatorForm("Add Workflow Step", this.modalAddAndUpdateWorkflowStep)
			if (!returnPayloadAndValidate.isValid) {
				this.$toastNotifPrime('error', "Validation failed", "There values are empty")
				return false
			};

			this.modalAddAndUpdateWorkflowStep.onLoad = true
			setTimeout(async () => {
				try {
					if (this.wfStepNoteForModalAddAndUpdate.action === 'Create') {
						await api(this, workflowService.diagramStepCreate(returnPayloadAndValidate.payload))
					} else {
						await api(this, workflowService.diagramStepUpdate(this.wfStepNoteForModalAddAndUpdate.certainStepClickedId, returnPayloadAndValidate.payload))
					}

					this.getStepWorkflow()
					// this.getDiagram();
				} catch (error) {
					this.handleErrorObjectNested(error)
				} finally {
					this.modalAddAndUpdateWorkflowStep.onLoad = false
					this.wfStepNoteForModalAddAndUpdate.visible = false
					this.wfStepNoteForModalAddAndUpdate.action = 'Create'
					this.wfStepNoteForModalAddAndUpdate.certainStepClicked = false
					this.wfStepNoteForModalAddAndUpdate.certainStepClickedKey = ''
					this.wfStepNoteForModalAddAndUpdate.certainStepClickedId = null
				}
			}, 500)
		},
		deleteWorkflowStep() {
			// VALIDASI, STEP HARUS TIDAK ADA DI DIAGRAM VIEW
			const stepKey = this.wfStepNoteForModalAddAndUpdate.certainStepClickedKey
			const stepId = this.wfStepNoteForModalAddAndUpdate.certainStepClickedId
			const isInUsedNodes = Object.values(this.usedNodes).includes(stepKey)
			const isInEdges = this.diagram.edges.some(
				edge => edge.source === stepKey || edge.target === stepKey
			)
			if (isInUsedNodes || isInEdges) {
				this.errorPopUpMsg('This workflow step is currently used in the diagram. Please remove the step and its edges from the diagram, then click save diagram first!')
				return isInUsedNodes || isInEdges
			}

			this.confirmDialog("You won't be able to revert this step!", "delete it").then((result) => {
				if (result.isConfirmed) {
					this.onLoadDiagram = true
					api(this, workflowService.diagramStepDelete(stepId)).then(() => {
						this.getStepWorkflow()
						// this.getDiagram();
					}).catch((error) => {
						this.handleErrorObjectNested(error)
					}).finally(() => {
						this.onLoadDiagram = false
						this.wfStepNoteForModalAddAndUpdate.action = 'Create'
						this.wfStepNoteForModalAddAndUpdate.certainStepClicked = false
						this.wfStepNoteForModalAddAndUpdate.certainStepClickedKey = ''
						this.wfStepNoteForModalAddAndUpdate.certainStepClickedId = null
					})
				}
			})

		},
		cloneWorkflowStep() {
			this.modalCloneWorkflowStep = {
				visible: true,
				description_clone_step: '',
				workflow_step_template: '',
				onLoad: false
			}
		},
		toCloneWorkflowStep() {
			this.modalCloneWorkflowStep.onLoad = true
			let payload = { "description": this.modalCloneWorkflowStep.description_clone_step }
			setTimeout(async () => {
				try {
					await api(this, workflowService.diagramStepCopy(this.modalCloneWorkflowStep.workflow_step_template, payload))
					this.getStepWorkflow()
					// this.getDiagram();
				} catch (error) {
					this.handleErrorObjectNested(error)
				} finally {
					this.modalCloneWorkflowStep.visible = false
					this.modalCloneWorkflowStep.onLoad = false
				}
			}, 500)
		},
		conditionParams() {
			this.cardConditionParams.visible = true
			this.cardConditionParams.onLoad = false
			this.cardConditionParams.loadTimeout = null

			// normalisasi condition_params jadi array, karena dari API bisa berbentuk object { param: [...] }
			let params = this.cardConditionParams.data.condition_params
			if (typeof params === 'string') {
				try { params = JSON.parse(params) } catch (e) { params = [] }
			}
			if (params && !Array.isArray(params)) {
				params = Array.isArray(params.param) ? params.param : []
			}
			this.cardConditionParams.data.condition_params = params || []

			if (this.cardConditionParams.data.condition_params.length <= 0) {
				let newParams = { "column": "", "operator": "AND", "values": [{ "operation": "", "condition": "", "from": "", "to": "" }] }
				this.cardConditionParams.data.condition_params.push(newParams)
			} else {
				// pastikan card pertama selalu AND & card existing punya field operation
				this.cardConditionParams.data.condition_params.forEach((param) => {
					// normalisasi values jadi array of object
					if (param.values && !Array.isArray(param.values)) {
						param.values = [param.values]
					} else if (!param.values) {
						param.values = [{ "operation": "", "condition": "", "from": "", "to": "" }]
					}

					// Pastikan field 'to' ada di setiap value agar tetap terkirim ke API
					param.values.forEach(val => {
						if (val.to === undefined) val.to = ""
					})
				})
			}
		},
		addParamsOrValuesArr(type, rowId = null) {
			this.cardConditionParams.onLoad = true
			if (type === 'params') {
				let newParams = {
					"column": "",
					"operation": this.cardConditionParams.data.condition_params.length <= 0 ? "AND" : "",
					"values": [{ "operation": "", "condition": "", "from": "", "to": "" }]
				}

				this.cardConditionParams.data.condition_params.push(newParams)
			} else if (type === 'valuesArr') {
				let newOp = { "operation": "", "condition": "", "from": "", "to": "" }

				this.cardConditionParams.data.condition_params[rowId].values.push(newOp)
			}
			this.cardConditionParams.onLoad = false
		},
		deleteParamsOrValuesArr(type, rowId, rowValId = null) {
			this.cardConditionParams.onLoad = true
			if (type === 'params') {
				this.cardConditionParams.data.condition_params.splice(rowId, 1);
				// card pertama harus selalu AND
				if (this.cardConditionParams.data.condition_params.length > 0) {
					this.cardConditionParams.data.condition_params[0].operator = "AND"
				}
			} else if (type === 'valuesArr') {
				this.cardConditionParams.data.condition_params[rowId].values.splice(rowValId, 1)
			}
			this.cardConditionParams.onLoad = false
		},
		saveParams() {
			this.errorMessageParam = []
			let isValid = this.validatorForm('Save Params', this.cardConditionParams.data.condition_params)
			if (!isValid) {
				this.$toastNotifPrime('error', "Validation failed", "These values are empty")
				return false
			};

			this.cardConditionParams.onLoad = true
			let payload = {
				"wf_code": this.cardConditionParams.data.wf_code || this.wfcCode,
				"condition": this.cardConditionParams.data.condition,
				"condition_params": {
					"param": this.cardConditionParams.data.condition_params
				}
			};
			setTimeout(async () => {
				try {
					if (this.cardConditionParams.data.id) {
						await api(this, workflowService.editCondition(this.cardConditionParams.data.id, payload))
					} else {
						await api(this, workflowService.addCondition(payload))
					}

					this.getStepWorkflow()
					// this.getDiagram();
				} catch (error) {
					this.handleErrorObjectNested(error)
				} finally {
					this.cardConditionParams.visible = false
					this.cardConditionParams.onLoad = false
				}
			}, 500)
		},
		errorPopUpMsg(value) {
			this.$swal({
				icon: 'error',
				title: 'Error',
				text: value,
			});
		},
		deleteErrorFieldModal(field) {
			delete this.errorMessage[field]
		},
		deleteErrorParamsFieldModal(id, field, valueFieldId = null, valueFieldVal = null) {
			if (valueFieldId !== null && valueFieldVal !== null) {
				if (this.errorMessageParam[id] && this.errorMessageParam[id][field]?.[valueFieldId]) {
					delete this.errorMessageParam[id][field][valueFieldId][valueFieldVal];

					if (Object.keys(this.errorMessageParam[id][field][valueFieldId]).length === 0) {
						delete this.errorMessageParam[id][field][valueFieldId];
					}
				}
			} else {
				if (this.errorMessageParam[id] && this.errorMessageParam[id][field]) {
					delete this.errorMessageParam[id][field];
				}
			}
		},
		handleErrorObjectNested(error) {
			if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
				const errorData = error.response?.data?.data;

				if (typeof errorData === 'object' && errorData !== null) {
					for (const key in errorData) {
						if (Object.prototype.hasOwnProperty.call(errorData, key)) {
							const match = key.match(/^items\.(\d+)\.(.+)$/);
							if (match) {
								error.response.data.data[key].forEach(message => {
									this.$toastNotifPrime('error', error.response.data.message, `${message} in row ${parseInt(match[1]) + 1}`)
								})
							} else {
								this.$toastNotifPrime('error', error.response.data.message, errorData[key]);
							}
						}
					}
				}
			}
		},
		validatorForm(fitur, data) {
			let isValid = true;
			let payload = {}

			if (fitur === 'Save Params') {
				const requiredField = [{ key: "column", message: "Column" }, { key: "operation", message: "Operation" }, { key: "condition", message: "Condition" }, { key: "from", message: "From" }];

				data.forEach((item, idx) => {
					const errorObj = {};
					const columnField = requiredField.find(f => f.key === "column");
					if (!item.column) {
						errorObj["column"] = `${columnField.message} is required`
					};

					if (idx > 0 && !item.operator) {
						errorObj["operator"] = `Operator is required`
					};

					item.values.forEach(valueItem => {
						requiredField.forEach(field => {
							if (field.key !== "column") {
								const val = valueItem[field.key];
								const isEmpty = Array.isArray(val) ? val.length === 0 : (val === undefined || val === null || val === "");
								if (isEmpty) {
									errorObj[field.key] = `${field.message} is required`
								};
							}
						});
					});

					if (Object.keys(errorObj).length > 0) {
						this.errorMessageParam[idx] = errorObj;
						isValid = false;
					}
				});

			} else if (fitur === "Add Workflow Step") {
				const action = data.action;
				payload = {
					wfc_code: data.wfcCode,
					action: action,
					description: data.description,
					next_step: null,
					data: {}
				}

				const validations = {
					umum: {
						action: 'Action is required',
						description: 'Description is required'
					},
					notification: {
						notification_template_code: 'Notification Template is required',
						position: 'Position is required',
						to: 'Parameter is required',
						values: 'Values is required',
					},
					update_value: {
						action_config: 'Action Config is required',
					},
					script: {
						script_code: 'Script is required',
						color_set_result: 'Result is required',
						color: 'Color is required',
					},
					approval: {
						// department: 'Department is required',
						// section: 'Section is required',
						// sub_section: 'Sub Section is required',
						to: 'Parameter is required',
						values: 'Values is required',
						color_set_result: 'Result is required',
						color: 'Color is required',
					}
				};

				// VALIDASI SETIAP FIELD
				const fieldsToValidate = { ...validations.umum, ...(validations[action] || {}) };
				for (const [field, errorMsg] of Object.entries(fieldsToValidate)) {
					if (!['color_set_result', 'color'].includes(field) && !(['to', 'values'].includes(field) && ['approval', 'notification'].includes(this.modalAddAndUpdateWorkflowStep.action))) {
						if (!this.modalAddAndUpdateWorkflowStep[field]) {
							this.errorMessage[field] = errorMsg
							isValid = false;
						}
					} else if (['color_set_result', 'color'].includes(field)) {
						this.modalAddAndUpdateWorkflowStep.color_set_result.forEach((item, idx) => {
							if (!item[field]) {
								if (!Array.isArray(this.errorMessage.color_set_result)) {
									this.errorMessage.color_set_result = [];
								}
								if (!this.errorMessage.color_set_result[idx]) {
									this.errorMessage.color_set_result[idx] = {};
								}
								this.errorMessage.color_set_result[idx][field] = errorMsg;
								isValid = false;
							}
						})

					} else if (['to', 'values'].includes(field) && ['approval', 'notification'].includes(this.modalAddAndUpdateWorkflowStep.action)) {
						this.modalAddAndUpdateWorkflowStep.to.forEach((item, idx) => {
							// section_emcr & sub_section_emcr tidak mandatory, kosong berarti empty array
							// plant_emcr, position_id, creator_emcr juga tidak mandatory
							if (field === 'values' && ['section_emcr', 'sub_section_emcr', 'plant_emcr', 'position_id', 'creator_emcr'].includes((item.to || '').toLowerCase())) {
								return;
							}
							if (!item[field]) {
								if (!Array.isArray(this.errorMessage.to)) {
									this.errorMessage.to = [];
								}
								if (!this.errorMessage.to[idx]) {
									this.errorMessage.to[idx] = {};
								}
								this.errorMessage.to[idx][field] = errorMsg;
								isValid = false;
							}
						})
					}
				}

				// VALIDASI ACTION CONFIG HARUS JSON VALID (update_value)
				let parsedActionConfig = null
				if (action === 'update_value' && this.modalAddAndUpdateWorkflowStep.action_config) {
					try {
						parsedActionConfig = JSON.parse(this.modalAddAndUpdateWorkflowStep.action_config)
					} catch (e) {
						this.errorMessage['action_config'] = 'Action Config must be a valid JSON'
						isValid = false;
					}
				}

				// BUAT PAYLOAD
				const specificFields = Object.keys({ ...(validations[action] || {}) });
				const payloadColorSetResult = {};
				let payloadReceivers = [];

				if (specificFields.includes("color_set_result") && Array.isArray(this.modalAddAndUpdateWorkflowStep.color_set_result)) {
					this.modalAddAndUpdateWorkflowStep.color_set_result.forEach(item => {
						if (!(item.color_set_result in this.modalAddAndUpdateWorkflowStep.result)) {
							this.modalAddAndUpdateWorkflowStep.result[item.color_set_result] = null;
						}
						payloadColorSetResult[item.color_set_result] = item.color;
					});
				}
				if (['approval', 'notification'].includes(this.modalAddAndUpdateWorkflowStep.action) && Array.isArray(this.modalAddAndUpdateWorkflowStep.to)) {
					payloadReceivers = this.modalAddAndUpdateWorkflowStep.to.map(iv => ({
						to: iv.to,
						values: Array.isArray(iv.values) ? iv.values : (iv.values ? [iv.values] : [])
					}));
				}
				payload.data = specificFields.reduce((rtrn, field) => {
					if (this.modalAddAndUpdateWorkflowStep[field] !== undefined) {
						if (field !== "color_set_result" && !(field === "to" && ['approval', 'notification'].includes(this.modalAddAndUpdateWorkflowStep.action)) && field !== "values" && field !== "action_config") {
							rtrn[field] = this.modalAddAndUpdateWorkflowStep[field];
						}
					}
					return rtrn;
				}, {
					...(this.modalAddAndUpdateWorkflowStep.result && Object.keys(this.modalAddAndUpdateWorkflowStep.result).length && { result: this.modalAddAndUpdateWorkflowStep.result }),
					...(this.modalAddAndUpdateWorkflowStep.action === 'notification' && { result: [] }),
					...(['approval', 'notification'].includes(this.modalAddAndUpdateWorkflowStep.action) && this.modalAddAndUpdateWorkflowStep.scope && { scope: this.modalAddAndUpdateWorkflowStep.scope }),
					...(Object.keys(payloadColorSetResult).length && { color_set_result: payloadColorSetResult }),
					...(payloadReceivers.length && { receivers: payloadReceivers }),
					...(parsedActionConfig && { action_config: parsedActionConfig })
				});
			}

			return (fitur === "Add Workflow Step") ? { "isValid": isValid, "payload": payload } : isValid;
		}
	}
}
</script>
<style>
.disabled-link {
	color: grey;
	cursor: not-allowed;
}

.disabled-link:hover {
	color: grey;
}
</style>
